import {
  BUTTON,
  EDITABLE_LINK_BUTTON,
  LAYOUT_COLUMNS,
  LAYOUT_LIST,
  TEXT
} from '../items';
import { Translator } from '../Translator';
import { CardHelper } from './itemHelpers/CardHelper';
import { ItemOfType } from './itemHelpers/types';
import { translate } from './translate';
import { useEditorStore } from '~/shell/Store';

const getButtonId = (item: ItemOfType<'Card'>) =>
  item.items && item.items.length > 0 && item.items[0].id
    ? item.items[0].id
    : `${item.id}_button`;

const getButtonTitle = (item: ItemOfType<'Card'>) =>
  item.items && item.items.length > 0 && item.items[0].title
    ? item.items[0].title
    : 'More';

// GraphQL returns 'url', REST (editor) returns 'subtitle' for the button URL
const getButtonUrl = (item: ItemOfType<'Card'>) => {
  if (!item.items || item.items.length === 0)
    return 'https://www.easyllama.com/';
  const btn = item.items[0] as Record<string, unknown>;
  return (btn.url || btn.subtitle || 'https://www.easyllama.com/') as string;
};

export const Interactive8: Translator = sequence => {
  const { contentEditable } = useEditorStore.getState();

  return translate(sequence, item => {
    switch (item.__typename) {
      case 'Card': {
        const cardItem = item as ItemOfType<'Card'>;
        const buttonId = getButtonId(cardItem);
        const buttonTitle = getButtonTitle(cardItem);
        const buttonUrl = getButtonUrl(cardItem);

        const buttonDefinition = contentEditable
          ? {
              type: EDITABLE_LINK_BUTTON as typeof EDITABLE_LINK_BUTTON,
              id: buttonId,
              values: {
                url: buttonUrl
              },
              items: [
                {
                  type: TEXT as typeof TEXT,
                  id: `${buttonId}_title`,
                  values: {
                    value: buttonTitle,
                    variant: 'text',
                    allowNewLines: false,
                    textAlignment: false,
                    disableRewrite: true
                  },
                  items: [] as never[]
                }
              ]
            }
          : {
              type: BUTTON as typeof BUTTON,
              id: buttonId,
              values: {
                type: 'link',
                title: buttonTitle,
                url: buttonUrl,
                showShadow: true
              },
              items: [] as never[]
            };

        return {
          id: cardItem.id,
          type: LAYOUT_LIST,
          values: {
            align: 'center'
          },
          items: [
            CardHelper(
              {
                ...cardItem,
                title: '',
                body: ''
              },
              {
                width: '80vw',
                height: 'auto',
                padding: { _: '0px', md: '60px' },
                extraItems: [
                  {
                    id: `${cardItem.id}_title`,
                    type: TEXT,
                    values: {
                      value: cardItem.title,
                      variant: 'heading1'
                    },
                    items: []
                  },
                  {
                    type: LAYOUT_COLUMNS,
                    id: '1',
                    values: {
                      gridTemplateColumns: '1fr'
                    },
                    items: [
                      {
                        id: `${cardItem.id}_body`,
                        type: TEXT,
                        values: {
                          value: cardItem.body
                        },
                        items: []
                      },
                      buttonDefinition
                    ]
                  }
                ]
              }
            )
          ]
        };
      }
      default:
        return null;
    }
  });
};
